export default {
    dataIterator: {
        rowsPerPageText: 'Items:',
        rowsPerPageAll: 'All',
        pageText: '{0}-{1} di {2}',
        noResultsText: 'No results found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
    },
    dataTable: {
        rowsPerPageText: 'Rows page:'
    },
    noDataText: 'No items available',
    generic: {
        executeLogin: "Login",
        newAccount: "New account? Sign up",
        station_statues:{
            ready: "on-line",
            offline: "off-line",
            out_of_service: "out of service",
            maintenance: "maintenance"
        },
        bay_statues: {
            READY: "Ready",
            OUT_OF_SERVICE: "Out of service",
            FAULTY: "Out of service"
        },
        bay_uses: {
            SHARING: "bike-sharing",
            PRIVATE: "private recharge",
            CAR: "car recharge"
        },
        bay_usage_states: {
            PRELIEVO: "pick-up",
            RICARICA: "recharge",
            RICONSEGNA: "delivery",
            NONE: "Occupied"
        }
    },
    Login: {
        newAccount: "New account? Sign up",
        lostPassword: "Forgot password",
        enter: "Log In",
        loginSuccesfully: "Login successful!",
        loginSuccesfullyTitle: "ACCESS DONE",
        errors: {
            unauthorized: "Username or Password wrong!",
            not_enabled: "User not enabled, check your e-mail to confirm registration."
        }
    },
    ResetPassword: {
        usernamePlaceholder: "Username",
        emailPlaceholder: "E-mail",
        resetPassword: "Password Recovery",
        successTitleReset: "REQUEST OF PASSWORD RESET DONE",
        successReset: "Request of password reset sent to your e-mail. Check your e-mail and complete the operations",
        errors: {
            base: {
                no_user: "Account not found!",
                unexpected_error: "Unexpected error, contact the administration"
            }
        }
    },
    NewAccount: {
        mobilePhonePlaceholder: "Mobile phone *",
        smscodePlaceholder: "SMS Code *",
        namePlaceholder: "Name *",
        surnamePlaceholder: "Surname *",
        birthDatePlaceholder: "Birth Date *",
        phonePlaceholder: "Phone number *",
        emailPlaceholder: "E-mail *",
        badgePlaceholder: "Smart Card",
        usernamePlaceholder: "Username *",
        passwordPlaceholder: "Password *",
        passwordConfirmationPlaceholder: "Confirm password *",
        languagePlaceholder: "Language",
        residenceAddressPlaceholder: "Residence address *",
        residenceNumberPlaceholder: "Residence house number *",
        residenceCapPlaceholder: "Residence postal code *",
        residenceCityPlaceholder: "Residence city *",
        residenceDistrictPlaceholder: "Residence district *",
        residenceCountryPlaceholder: "Residence country *",
        nationalIdentificationNumberPlaceholder: "Fiscale code",
        newUser: "NEW ACCOUNT REGISTRATION",
        infoAccess: "Access informations",
        privacyConsent: "I have read the PRIVACY STATEMENT pursuant to EU regulation 2016/679",
        regulationAcceptance: "I declare that I have read and accept the regulation",
        Register: "Sign up",
        subscribeSuccesfullyTitle: "Account created successfully!",
        subscribeSuccesfully: "Perfect! You can start using the service",
        titlePopupError: "Error in account creation",
        messagePopupError: "Something went wrong. Try again!",
        successSubscription: "Account created successfully.",
        closePopupPrivacy: "Close",
        closePopupRegulation: "Close",
        cell_verification_process: "Check the mobile phone number",
        check_phone_number: "Check phone number",
        sms_code_request: "Request code",
        invalidPhoneNumber: "Invalid phone number",
        invalidSmsCode: "Invalid code",
        errors: {
            lastname: {
                blank: "Required field"
            },
            birth_date: {
                blank: "Required field",
                should_be_adult: "non-compliant"
            },
            email: {
                blank: "Required field",
                invalid: "E-mail format not valid"
            },
            username: {
                blank: "Required field",
                taken: "It already exists"
            },
            password: {
                blank: "Required field",
                invalid: "The password must be at least 10 characters long and must contain letters and numbers",
                must_same_password_confirm: "Password and password confirmation must match"
            },
            password_confirmation: {
                blank: "Required field",
                confirmation: "Password and password confirmation must match"
            },
            gdpr_role: {
                inclusion: "Required field"
            },
            regulation_acceptance: {
                inclusion: "Required field"
            },
            residence_address: {
                blank: "Required field"
            },
            residence_number: {
                blank: "Required field"
            },
            residence_cap: {
                blank: "Required field"
            },
            residence_city: {
                blank: "Required field"
            },
            residence_district: {
                blank: "Required field"
            },
            residence_country: {
                blank: "Required field"
            },
            national_identification_number: {
                taken: "Fiscal code already exists in the system",
                blank: "Required field",
                invalid_format: "Invalid format"
            }


        }

    },
    Application: {
        account: "Account",
        statistics: "Stats",
        logout: "Logout",
        version: "Vers.",
        rules: "Rules",
        closePopupRules: "Close"
    },
    PopUpStation: {
        goToStation: "Go to the station",
        close: "Close",
        tableData: {
            name: "Station"
        },
        noResult: "Station not found"
    },
    StationInfo: {
        name: "Station",
        availableVehicles: "Vehicles available",
        totalCount: "Total docks",
        freeBay: "Free docks",
        address: "Address"
    },
    Station: {
        loginToStation: "Access to the station",
        position: "Dock",
        bayUsageBusyState: "Occupied",
        availableFor: "Available for ",
        usages: {
            private: "Private e-bike recharge",
            vehicle_private: "Private electric vehicle recharge",
            sharing: "Public e-bike recharge",
            car: "Electric vehicle recharge",
            charger: "Recharge dock"
        }
    },
    BasePopUp: {
        close: "Close"
    },
    StationLogin: {
        warningMessage: "ATTENTION!",
        message: "Insert the access code on the Station display.",
        signIn: "Access",
        codePlaceholder: "Code Access",
        goodJobMessage: "Well done!",
        messageSuccessLogin: "You have successfully authenticated to the Station",
        messageSuccessLoginNoMonitorCode:"You are logged in successfully, now use the buttons on the column",
        labelStation: "",
        instructions: "Follow the instructions on the Station display...",
        errorMessage: "The code is incorrect and does not correspond to the one on the Station display. Please try again by clicking on the following button...",
        retry: "Try again"
    },
    Account: {
        editUser: "MODIFY ACCOUNT",
        editAccount: "Access informations",
        namePlaceholder: "Name *",
        surnamePlaceholder: "Surname *",
        birthDatePlaceholder: "Birth Date *",
        phonePlaceholder: "Phone number",
        residenceAddressPlaceholder: "Residence address *",
        residenceNumberPlaceholder: "Residence house number *",
        residenceCapPlaceholder: "Residence postal code *",
        residenceCityPlaceholder: "Residence city *",
        residenceDistrictPlaceholder: "Residence district *",
        residenceCountryPlaceholder: "Residence country *",
        nationalIdentificationNumberPlaceholder: "Fiscal code",
        badgePlaceholder: "Smart Card",
        emailPlaceholder: "E-mail *",
        languagePlaceholder: "Language",
        update: "Refresh",
        updateSuccesfullyTitle: "Well done!",
        updateSuccesfully: "Account informations successfully updated.",
        confirmNewPasswordPlaceholder: "Confirm password *",
        newPasswordPlaceholder: "New Password *",
        currentPasswordPlaceholder: "Current password *",
        updateSuccesfullyAccountTitle: "Well done!",
        updateAccountSuccesfully: "Access informations updated",
        errors:{
            lastname:{
                blank: "required field"
            },
            birth_date: {
                blank: "Required field",
                should_be_adult: "non-compliant"
            },
            email: {
                blank: "required field"
            },
            password: {
                must_same_password_confirm: "Password and password confirmation must match",
                blank: "required field",
                invalid: "The password must be at least 10 characters long and must contain letters and numbers"
            },
            old_password: {
                unauthorized: "Current password not correct",
                blank: "Required field"
            },
            password_confirmation: {
                blank: "Required field",
                confirmation: "Password and password confirmation must match"
            },
            residence_address: {
                blank: "Required field"
            },
            residence_number: {
                blank: "Required field"
            },
            residence_cap: {
                blank: "Required field"
            },
            residence_city: {
                blank: "Required field"
            },
            residence_district: {
                blank: "Required field"
            },
            residence_country: {
                blank: "Required field"
            },
            national_identification_number: {
                taken: "Fiscal code already exists in the system",
                blank: "Required field",
                invalid_format: "Invalid format"
            }
        }

    },
    Statistics: {
        servicePlaceholder: "Service",
        dateFromPlaceholder: "From",
        dateToPlaceholder: "To",
        tableHeaders: {
            vehicle: "Vehicle"
        },
        services: {
            sharing_unit: "Bike-sharing",
            car_unit: "Car recharges",
            recharge_unit: "Vehicles recharges"
        },
        noResult: "No results",
        showMore: "Show more results"
    },
    NewPassword: {
        passwordPlaceholder: "New password",
        passwordConfirmationPlaceholder: "Confirm New password",
        noTokenError: "Token for reset password not found",
        successPasswordChanged: "Now you can log in with your new password",
        successPasswordChangedTitle: "PASSWORD CHANGED",
        changePassword: "Change password",
        errors: {
            password: {
                blank: "Required field",
                invalid: "The password must be at least 10 characters long and must contain letters and numbers",
                must_same_password_confirm: "Password and password confirmation must match"
            }
        }
    },
    AppUpgrade: {
        newUpdates: "Update",
        wouldYouUpgrade: "A new version is available, do you want to update the application?",
        update: "Update",
        discardUpdate: "Cancel"

    },
    AddToHome: {
        add: "Add",
        discardAdd: "Cancel",
        installApp: "Install application",
        installAppMessage: "For a better experience we recommend adding the application to the home screen",
        howToInstall: "For a better experience we recommend adding the application to the home screen",
        ok: "OK"

    },
    App: {
        offlineMessage: "To use the application, internet connection is required",
        offlineMessageTitle: "OPS! YOU ARE OFFLINE"
    },
    Credit: {
        availableCredit: "CREDIT",
        rechargeCredit: "RECHARGE CREDIT",
        paymentsArchive: "Archive payments",
        currency: "€",
        noPaymentMethodsMessage: "It is not possible to recharge your credit because no payment methods are available",
        noPaymentMethods: "NO PAYMENT METHODS"
    },
    Braintree: {
        recharge: "Recharge",
        successPayment: "WELL DONE!",
        successPaymentMessage: "Payment successfully done",
        errorPayment: "ERROR!",
        errorPaymentMessage: "Error in the processing of payment request"
    },
    Stripe: {
        recharge: "Recharge",
        successPayment: "WELL DONE!",
        successPaymentMessage: "Payment successfully done",
        errorPayment: "ERROR!",
        errorPaymentMessage: "Error in the processing of payment request",
        waitingPayment: "WAIT",
        waitingPaymentMessage: "Processing payment...",
        unexpectedError: "Unexpected error",
        processingPayment: "Payment in progress"
    },
    Stations: {
        labelStation: "Station",
        address: "Address",
        totalSeats: "Total docks",
        availableSeats: "Free docks",
        availableVehicles: "Available vehicles"

    },
    UpdateRequestedUserInfo: {
        warningMessage: "Please complete your user profile with the missing information"
    },
    languages: {
        "IT": "Italiano",
        "EN": "English",
        "ES": "Español",
        "DE": "Deutsch"
    },

    "CurrentSharing": {
      "duration": "Usage time",
      "startBay": "Starting station",
      "takeAt": "Start date/time",
      "title": "Usage information",
      "bike_lock": {
        "button": "UNLOCK LOCK",
        "success_message": "Lock unlock confirmed",
        "failure_message": "Unlock failed, please try again."
      }
    }

};
